import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../landing/Header";
import Footer from "../landing/Footer";
import CookieBanner from "../landing/CookieBanner";
import useSeo from "../landing/useSeo";
import { SITE } from "../landing/siteConfig";
import "../landing/landing.css";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [status, setStatus] = useState(null);

    const navigate = useNavigate();

    useSeo({
        title: `Вход в личный кабинет — ${SITE.brand}`,
        description: `Вход в личный кабинет ${SITE.brand} — управляйте кампаниями и получайте лиды.`,
        path: "/login",
        noindex: true,
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        setStatus(null);

        const payload = {
            username: email,
            password: password,
        };
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(payload),
        };

        fetch(`${process.env.REACT_APP_BACKEND}/api/login`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setStatus({ type: "err", text: data.message });
                } else {
                    navigate("/leads");
                }
            })
            .catch((error) => {
                setStatus({ type: "err", text: String(error) });
            });
    };

    return (
        <div className="lp">
            <Header />
            <section className="authsect">
                <div className="wrap">
                    <div className="auth-card auth-card--page">
                        <span className="eyebrow">Личный кабинет</span>
                        <h1 className="auth-card__title">Вход</h1>
                        <p className="auth-card__sub">
                            Войдите, чтобы управлять кампаниями и получать лиды.
                        </p>
                        <form onSubmit={handleSubmit}>
                            <div className="form__row">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    autoComplete="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form__row">
                                <label htmlFor="password">Пароль</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>

                            <button type="submit" className="btn btn--lg btn--block">
                                Войти
                            </button>

                            {status && (
                                <p className={`form__status is-${status.type}`}>{status.text}</p>
                            )}
                        </form>
                        <p className="auth-card__switch">
                            Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
                        </p>
                    </div>
                </div>
            </section>
            <Footer />
            <CookieBanner />
        </div>
    );
};

export default Login;
